import { useEffect, useState } from "react";
import { formatDuration } from "../../lib/format";

export function CallTimer({ since }: { since: string | null }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!since) return;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [since]);
  if (!since) return null;
  return <span className="tabular" aria-label="Call duration">{formatDuration((now - new Date(since).getTime()) / 1000)}</span>;
}
